import model from '../models-v2/bookkeeping/zus-package';
import beforeZusEnterMiddleware from '../router/beforeZusEnterMiddleware';

export default [
  {
    path: '/zus-packages',
    name: 'zus-packages',
    components: {
      default: () => import('../pages/data-grid.vue'),
      topRightSection: () => import('../components-v2/top-right-section.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'ZUS', url: '/zus-packages' },
        { title: 'Deklaracje', url: '/zus-packages' },
      ],
      rule: 'editor',
      search: false,
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
    beforeEnter: beforeZusEnterMiddleware,
  },
  {
    path: '/zus-packages/add',
    name: 'zus-packages-add',
    components: {
      default: () => import('../pages/model-form.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'ZUS', url: '/zus-packages' },
        { title: 'Deklaracje', url: '/zus-packages' },
      ],
      rule: 'editor',
      search: false,
      module: 'CRM',
    },
    props: {
      default: (props) => ({ ...props, model }),
    },
    beforeEnter: beforeZusEnterMiddleware,
  },
];
